import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { reaction } from 'mobx';
import { observer } from 'mobx-react';

import messages from './PressRoomArticleView.intl';

import ArticleDetail from 'common/components/ArtricleDetailPage/ArticleDetailPage';

import { ANCHOR } from 'common/consts/common';

import LanguageService from 'services/Language.service';
import PressRoomNewsStore from 'stores/PressRoomNews.store';
import ContentStore from 'stores/Content.store';
import Location from 'stores/Location.store';

@injectIntl
@withRouter
@observer
export default class PressRoomArticleView extends Component {
  state = {
    article: null,
    otherNews: []
  };

  async getPressArticle(slug) {
    const availableLanguages = LanguageService.getSortedLanguages();

    let pressArticle = await availableLanguages.reduce(
      (previousPromise, nextLang) => {
        return previousPromise.then(
          result =>
            result ||
            PressRoomNewsStore.getPressRoomNewsItemBySlug(slug, nextLang)
        );
      },
      Promise.resolve()
    );

    if (pressArticle) {
      if (LanguageService.getLang() !== pressArticle.system.language) {
        pressArticle = await PressRoomNewsStore.getPressRoomNewsItemById(
          pressArticle.id
        );
      }
    }
    LanguageService.adjustSlugToLanguage(this, pressArticle);

    pressArticle
      ? this.setState({ article: pressArticle })
      : this.props.history.push(
          `${ANCHOR.PRESSROOM[LanguageService.getLang()]}`
        );
  }

  contactPerson = {};

  async componentDidMount() {
    reaction(
      () => ContentStore.isLoaded,
      () => {
        this.contactPerson = ContentStore.content
          ? ContentStore.content.pressRoomContactPerson
          : {};
      },
      {
        fireImmediately: true
      }
    );
    let articleSlug = this.props.match.params.slug;

    this.getPressArticle(articleSlug);

    const otherNews = await PressRoomNewsStore.fetchOtherPressRoomNews();

    this.setState({
      otherNews: otherNews
    });
  }

  didComeFromListing() {
    const lastPath = Location.getLastLocation();
    return lastPath && lastPath.pathname === ANCHOR.PRESSROOM;
  }

  render() {
    const { article, otherNews } = this.state;

    return (
      <ArticleDetail
        messages={messages}
        otherNews={otherNews}
        didComeFromListing={this.didComeFromListing}
        article={article}
        defaultPreviousPath={ANCHOR.PRESSROOM}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/PressRoomArticle/PressRoomArticleView.js